import { SelectField, TFormField } from '@monorepo/forms';
import { useI18n } from '@monorepo/i18n';

const DeliveryPriceAppliedSelect = <
  TFormValues extends Record<string, any> = Record<string, any>
>(
  props: TFormField<TFormValues>
) => {
  const { t } = useI18n();
  const options = [
    { label: t('offer.form.deliveryPriceApplied.yes'), value: 1 },
    { label: t('offer.form.deliveryPriceApplied.no'), value: 0 }
  ];

  return <SelectField<TFormValues> options={options} {...props} />;
};

export default DeliveryPriceAppliedSelect;
